import { createSelector } from 'reselect';

export const getPopupsList = (state) => state.popups;

export const getPopupByName = (name) =>
  createSelector(getPopupsList, (item) => item[name]);
